import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import DealTableFilters from '../DealTableFilters';
import { DealSidebarDealsSection } from './DealSidebarDealsSection';
import DealSidebarGoalsSection from './DealSidebarGoalsSection';
import { DEALS_TAB, GOALS_TAB } from '../../constants/OverviewConstants';
import { getCompanyCurrency } from '../../selectors/multiCurrencySelectors';
import { getDealsList } from '../../selectors/dealsSelectors';
import { getIsUngatedToForecastingMultipleOutcomes } from '../../selectors/authSelectors';
import { getPortalConfig } from '../../selectors/forecastSelectors';
import { getOwnersMap } from '../../selectors/ownersSelectors';
import { getFilters } from '../../selectors/filtersSelectors';
import { getForecastCategoryProperty } from '../../selectors/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DealSidebarTabs = ({
  selectedTab,
  onSelectedChange,
  isLoading,
  isDealStageView,
  dealStages,
  id,
  isTeam,
  assigneeType
}) => {
  const currencyCode = useSelector(getCompanyCurrency);
  const deals = useSelector(getDealsList);
  const filterState = useSelector(getFilters);
  const forecastCategoryProperty = useSelector(getForecastCategoryProperty);
  const isUngatedToForecastingMultipleOutcomes = useSelector(getIsUngatedToForecastingMultipleOutcomes);
  const owners = useSelector(getOwnersMap);
  const portalConfig = useSelector(getPortalConfig);
  return /*#__PURE__*/_jsxs(Tabs, {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    panelStyles: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding: '0'
    },
    onSelectedChange: onSelectedChange,
    selected: selectedTab,
    children: [/*#__PURE__*/_jsxs(Tab, {
      tabId: DEALS_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.tabs.dealsTab"
      }),
      children: [/*#__PURE__*/_jsx(PanelSection, {
        paddingBlockStart: "300",
        paddingBlockEnd: "200",
        paddingInline: "600",
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(DealTableFilters, {
          ownerId: id,
          isDetailPage: false
        })
      }), /*#__PURE__*/_jsx(DealSidebarDealsSection, {
        currencyCode: isUngatedToForecastingMultipleOutcomes ? currencyCode : currencyCode,
        deals: deals,
        dealStages: dealStages,
        forecastCategoryProperty: forecastCategoryProperty,
        isDealStageView: isDealStageView,
        isTeam: isTeam,
        loading: isLoading,
        owners: owners,
        portalConfig: portalConfig
      })]
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: GOALS_TAB,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.tabs.goalsTab"
      }),
      children: /*#__PURE__*/_jsx(PanelSection, {
        paddingInline: "600",
        children: /*#__PURE__*/_jsx(DealSidebarGoalsSection, {
          assigneeType: assigneeType,
          id: id,
          isTeam: isTeam,
          pipelines: filterState.get('pipeline')
        })
      })
    })]
  });
};